export default __webpack_public_path__ + "static/media/image2.1c1bf84b.png";